@if (announcementBannerService.isVisible()) {
  <notification-bar [closable]="true" (onClose)="handleCloseNoti()">
    <span [innerHTML]="announcementBannerService.notification()"></span>
  </notification-bar>
}
